import { render, staticRenderFns } from "./shows.vue?vue&type=template&id=fe6bbcec&scoped=true"
import script from "./shows.vue?vue&type=script&setup=true&lang=js"
export * from "./shows.vue?vue&type=script&setup=true&lang=js"
import style0 from "./shows.vue?vue&type=style&index=0&id=fe6bbcec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6bbcec",
  null
  
)

export default component.exports